
<mat-card-content>
  <div style="min-height: 4px;">
    <app-loading [isCircle]="false" [hasLoaded]="!areasLoading"></app-loading>
  </div>
  <div *ngIf="!!areas?.length" style="display: flex; justify-content: flex-start;">
    <div *ngFor="let a of areas" id="area" style="height: 120px; padding-right: 1rem;" [attr.data-test]="'area'" [attr.data-testid]="a.title">
      <strong class="area-title">{{ a.title }}</strong><br>
      <img *ngIf="a.thumbUrl" class="area-thumb" [src]="a.thumbUrl" alt="geofence area thumbnail" />
    </div>
  </div>

  <div *ngIf="!!areas?.length && !!alert?.recipients?.featureLayers?.length">
    <div *ngFor="let layer of alert?.recipients?.featureLayers" style="padding-top: 0.5rem;" [attr.data-test]="'feature-layer'" [attr.data-testid]="layer.Name">
      <strong class="layer-title">{{ layer.Name }}:</strong>
      <span><br> &nbsp; {{ 'RecipientCount' | translate:locale.language }}: {{ getLayerRecipientCount(layer) }}</span>
      <span *ngIf="isGroupFilteringPermitted"><br> &nbsp; {{ getLayerFilterText(layer) }}</span>
    </div>
  </div>
</mat-card-content>